import React from 'react';
import PropTypes from 'prop-types';
import { UX2 } from '@wsb/guac-widget-core';
import dataAids from '../../../../constants/dataAids';
import ProductDetailAssets from '../../products/ProductDetailAssets';
import CheckoutButtons from '../../products/details/CheckoutButtons';
import { ProductReviews } from '../../products/Yotpo';
import CommonDetails from '../CommonDetails';
import getStyles from '../getStyles';
import SimilarProducts from '../SimilarProducts';
import ProductLabels from '../../products/details/ProductLabels';

const labelsContainer = {
  '@xs': {
    display: 'block'
  },
  '@sm': {
    display: 'none'
  }
};

function ProductDetail1(props) {
  const { Grid, Grid: { Cell } } = UX2.Component;
  const { Block, Text } = UX2.Element;
  const styles = getStyles(props);
  const { showSimilarProducts,  similarProducts = [] } = props;

  return (
    <Block style={{ position: 'relative' }}>
      <Grid size={ 12 }>
        <Cell xs={ 12 } sm={ 5 } pushSm={ 1 }>
          <Block style={ styles.assetsWrapper }>
            <ProductDetailAssets
              renderMode={ props.renderMode }
              product={ props.product }
              currentAssetIndex={ props.currentAssetIndex }
              onClickThumbnail={ props.onClickThumbnail }
              assetChangedByVariantSelection={
                props.assetChangedByVariantSelection
              }
              assetsVisible={ 4 }
              fetching={ props.fetching || props.processing || props.inSession }
              pdpImageCropMethod={ props.pdpImageCropMethod }
              pdpImageShape={ props.pdpImageShape }
              pdpLayout={ props.pdpLayout }
            />
          </Block>
        </Cell>
        <Cell xs={ 12 } sm={ 5 }>
          <Block>
            <Block style={{ marginBottom: 'large' }}>
              <Grid size={ 4 }>
                <Cell style={{ minWidth: '100%' }} xs={ 4 } md={ 3 }>
                  <Block
                    data-aid={ dataAids.PRODUCT_NAME_RENDERED }
                    tag='h1'
                    children={ props.product.name }
                    style={ styles.name }
                  />
                  { (props.product.ship_free || props.product.limited_edition) &&
                    <Block style={ labelsContainer } >
                      <ProductLabels product={ props.product } translate={ props.translate } />
                    </Block>
                  }
                  <CommonDetails { ...props } showProductLabels={ true } />
                </Cell>
              </Grid>
            </Block>
            <CheckoutButtons
              renderMode={ props.renderMode }
              category={ props.category }
              prices={ props.determinePrice() }
              { ...props.baseState }
              requiredFieldsBlank={ props.requiredFieldsBlank }
              isSelectedVariantInStock={ props.isSelectedVariantInStock }
              handleAddToCart={ props.handleAddToCart }
              handleApplePayClick={ props.handleApplePayClick }
              getOrderData={ props.getVariantData }
              phoneRequired={ props.stripeConfig.require_phone_number }
              isPaymentRequestEnabled={ props.stripeConfig.with_payment_request }
              translate={ props.translate }
            />
            <Text
              richtext
              data-aid={ dataAids.PRODUCT_DESCRIPTION_RENDERED }
              children={ props.description }
            />
          </Block>
        </Cell>
      </Grid>
      <Grid size={ 12 }>
        <Cell xs={ 12 }>
          <ProductReviews
            product={ props.product }
            renderMode={ props.renderMode }
          />
        </Cell>
      </Grid>
      {
        showSimilarProducts && similarProducts.length > 0 && (
          <SimilarProducts { ...props }/>
        )
      }
    </Block>
  );
}

ProductDetail1.propTypes = {
  assetChangedByVariantSelection: PropTypes.bool,
  baseState: PropTypes.object,
  category: PropTypes.string,
  currentAssetIndex: PropTypes.number,
  description: PropTypes.string,
  determinePrice: PropTypes.func,
  fetching: PropTypes.bool,
  handleAddToCart: PropTypes.func,
  handleApplePayClick: PropTypes.func,
  getVariantData: PropTypes.func,
  inSession: PropTypes.bool,
  isSelectedVariantInStock: PropTypes.bool,
  onClickThumbnail: PropTypes.func,
  pdpImageCropMethod: PropTypes.string,
  processing: PropTypes.bool,
  product: PropTypes.object,
  stripeConfig: PropTypes.object,
  renderMode: PropTypes.string,
  requiredFieldsBlank: PropTypes.bool,
  translate: PropTypes.func,
  pdpImageShape: PropTypes.string,
  showSimilarProducts: PropTypes.bool,
  similarProducts: PropTypes.array,
  pdpLayout: PropTypes.string.isRequired
};

export default ProductDetail1;
